import { createApp } from 'vue'
import PortalLogin from './PortalLogin.vue'
import { initSentry } from '../../shared/sentry.js'

const app = createApp(PortalLogin)
initSentry(app, { entry: 'portal-login' })
app.mount('#app')
